// extracted by mini-css-extract-plugin
export default {"box":"sms-create-instructions_box__W0sJa"};